// src/api/axiosConfig.js
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true, // schickt das vom Backend gesetzte Cookie mit
  timeout: 15000,
});

/**
 * Login/Logout-Helfer
 * - setAuthToken(token): speichert den JWT lokal und setzt den Authorization-Header
 * - clearAuthToken(): entfernt beides
 */
export function setAuthToken(token) {
if (token) {
    localStorage.setItem('token', token);
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    localStorage.removeItem('token');
    delete api.defaults.headers.common.Authorization;
  }
}
export function clearAuthToken() {
  setAuthToken(null);
}

// Request-Interceptor: falls noch kein Default-Header gesetzt ist, nimm Token aus localStorage
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response-Interceptor: auf 401/403 Token löschen (User ist nicht/ nicht mehr eingeloggt)
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err?.response?.status;
    if (status === 401 || status === 403) {
      clearAuthToken();
      // Optional: Redirect zur Login-Seite hier NICHT machen
      // (besser an zentraler Stelle im Router handeln)
    }
    return Promise.reject(err);
  }
);

export function createTask(payload) {
  // Backend erwartet: { board_id, title, status, assignee, details, ... }
  return api.post("/tasks", payload);
};

export async function uploadTaskAttachments(taskId, files) {
  const fd = new FormData(); files.forEach(f => fd.append('files', f));
  const { data } = await api.post(`/tasks/${taskId}/attachments`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return data.attachments;
}
export async function listTaskAttachments(taskId) {
  const { data } = await api.get(`/tasks/${taskId}/attachments`);
  return data.attachments;
}
export async function deleteTaskAttachment(taskId, attId) {
  const { data } = await api.delete(`/tasks/${taskId}/attachments/${attId}`);
  return data.ok;
};

/* --- Kommentar-Helper --- */
export async function listTaskComments(boardId, taskId) {
  const { data } = await api.get(`/boards/${boardId}/tasks/${taskId}/comments`);
  return data;
}
export async function addTaskComment(boardId, taskId, content, mentions = []) {
  const { data } = await api.post(`/boards/${boardId}/tasks/${taskId}/comments`, { content, mentions });
  return data;
}
export async function deleteTaskComment(commentId) {
  const { data } = await api.delete(`/comments/${commentId}`);
  return data;
}
/*Kommentar aktualisieren */
export async function updateTaskComment(commentId, content, mentions = []) {
  const { data } = await api.put(`/comments/${commentId}`, { content, mentions });
  return data;
}

/** Task als angesehen markieren (für neue Kommentare Tracking) */
export async function markTaskAsViewed(boardId, taskId) {
  const { data } = await api.post(`/boards/${boardId}/tasks/${taskId}/mark-viewed`);
  return data;
}

/** Alle Tasks eines Boards als angesehen markieren */
export async function markAllTasksAsViewed(boardId) {
  const { data } = await api.post(`/boards/${boardId}/mark-all-viewed`);
  return data;
}

export default api;
